<template>
	<component :is="dynamicComponent"></component>
</template>
<script>
	export default {
		name: 'Privacy',
		data() {
			return {
				dynamicComponent: null,
				gameData: this.$store.state.gameData
			};
		},
		mounted() {
			this.loadComponent();
		},
		methods: {
			async loadComponent() {
				const {
					default: component
				} = await import('@/views/privacy/' + this.gameData.language + '/privacy.vue');
				this.dynamicComponent = component;
			}
		}
	}
</script>
<style scoped>
	.text_privacy p {
		width: 100%;
		height: 100%;
		text-indent: 4ch;
	}

	.text_privacy {
		padding: 20px;
	}
</style>